import jQuery from 'jquery';
let $ = jQuery;

import 'HSNDIR/Service.js';

HSN.Service.CommerceService = function () {

};
HSN.Service.CommerceService.prototype = {
    AddToBag: function (data, config) {
        this._send('/bag/add-to-bag', data, config);
    },
    RemoveBagItem: function (data, config) {
        this._send('/checkout/bag-actions/remove-bag-item', data, config);
    },
    RemoveWarrantyFromBagItem: function (data, config) {
        this._send('/checkout/bag-actions/remove-warranty', data, config);
    },
    AddWarrantyToBagItem: function (data, config) {
        this._send('/checkout/bag-actions/add-warranty', data, config);
    },
    SaveItemForLater: function (data, config) {
        this._send('/checkout/bag-actions/save-item-for-later', data, config);
    },
    MoveItemToBag: function (data, config) {
        this._send('/checkout/bag-actions/move-item-to-bag', data, config);
    },
    ChangeItemSingleShipToAutoShip: function(data, config) {
        this._send('/checkout/bag-actions/change-item-to-autoship', data, config);
    },
    ChangeItemAutoShipToSingleShip: function(data, config) {
        this._send('/checkout/bag-actions/change-item-to-singleship', data, config);
    },
    GetBagFlyout: function (config) {
        this._ajaxGet('/bag-flyout', {}, config);
    },
    RemoveGiftOptions: function (data, config) {
        this._send('/checkout/bag-actions/remove-gift-options', data, config);
    },
    SaveGiftOptions: function (data, config) {
        this._send('/checkout/bag-actions/save-gift-options', data, config);
    },
    UpdatePaymentInfo: function (data, config) {
        this._send('/checkout/bag-actions/update-payment-info', data, config);
    },
    RemoveVipFinancing: function (data, config) {
        this._send('/checkout/bag-actions/remove-vip-financing', data, config);
    },
    UpdateShipping: function (data, config) {
        this._send('/checkout/bag-actions/update-shipping', data, config);
    },
    UpdateQuantity: function (data, config) {
        this._send('/checkout/bag-actions/update-quantity', data, config);
    },
    UpdateVariant: function (data, config) {
        this._send('/checkout/bag-actions/update-variant', data, config);
    },
    ApplyDiscount: function (code, config) {
        this._send('/checkout/bag-actions/apply-discount', { discountCode: code }, config);
    },
    RemoveDiscount: function (data, config) {
        this._send('/checkout/bag-actions/remove-discount', data, config);
    },
    ApplyKash: function (config) {
        this._send('/checkout/bag-actions/apply-kash', {}, config);
    },
    AddCharityItem: function (webpid, config) {
        this._send('/checkout/bag-actions/add-charity', { 'webpid': webpid }, config);
    },
    ProcessOrder: function (data, config) {
        this._send('/checkout/process-order', data, config);
    },
    SelectAddress: function (data, config) {
        this._send('/checkout/select-address', data, config);
    },
    RemoveAddress: function (data, config) {
        this._send('/checkout/remove-address', data, config);
    },
    ValidateAddress: function (data, config) {
        this._send('/checkout/validate-address', data, config);
    },
    AddEditAddressSave: function (data, config) {
        this._send('/checkout/add-edit-address-save', data, config);
    },
    PrescreenNoThanks: function (data, config) {
        this._send('/checkout/order-review/prescreen/no-thanks', data, config);
    },
    PrescreenCardOfferGet: function (data, config) {
        this._ajaxGet('/checkout/order-review/prescreen/card-offer', data, config);
    },
    SubmitAvsMatch: function (data, config) {
        this._send('/checkout/payment-confirmation/save', data, config);
    },
    UpdateLtlShippingPhoneNumber: function (data, config) {
        this._send('/checkout/order-review/save-shipping-phone', data, config);
    },
    EstimateTax: function (zipCode, config) {
        this._send('/checkout/bag-actions/estimate-tax', { zipCode: zipCode }, config);
    },
    ResubmitOrder: function (data, config) {
        this._send('/checkout/payment/resubmit', data, config);
    },
    ResubmitBillingAddress: function (data, config) {
        this._send('/checkout/billing-address/resubmit', data, config);
    },
    ResubmitFlexOrder: function (data, config) {
        this._send('/checkout/flex-error/resubmit', data, config);
    },
    ResubmitCardVerification: function (data, config) {
        this._send('/checkout/card-verification-retry/resubmit', data, config);
    },
    GetEditPaymentMethodForm: function (paymentIdentity, config) {
        this._ajaxGet('/checkout/add-edit-payment', { paymentIdentity: paymentIdentity, partialOnly: true }, config);
    },
    GetAddPaymentMethodForm: function (data, config) {
        this._ajaxGet('/checkout/add-edit-payment', data, config);
    },
    CreateAccount: function (data, config) {
        this._send('/account/create', data, config);
    },
    GetCityStateFromZip: function(data, config) {
        this._send('/account/city-state-from-zip', data, config);
    },
    ConvertGuest: function (data, config) {
        this._send('/checkout/convert-guest-account', data, config);
    },
    SetCardVerificationTransactionId: function (cardVerificationTransactionId, config) {
        this._send('/checkout/card-verification', { cardVerificationTransactionId: cardVerificationTransactionId }, config);
    },
    GetMoreOrderStatusOrders: function (data, config) {
        this._ajaxGet('/myaccount/order-status/get-more-orders', data, config);
    },
    UpdateBagPaymentProvider: function (data, config) {
        this._send('/checkout/bag-actions/update-payment-provider', data, config);
    },
    CreateEGiftOrder: function (data, config) {
        this._send('/products/egiftcard/save/', data, config);
    },
    ApplePayBagGet: function (data, config) {
        config.dataType = 'json';
        this._ajaxGet('/api/applepay-bag', data, config);
    },
    ApplePayValidate: function (data, config) {
        this._send('/api/applepay-validate', data, config);
    },
    ApplePayChangeShipping: function(data, config) {
        this._send('/api/applepay-change-shipping', data, config);
    },
    ApplePayComplete: function (data, config) {
        this._send('/api/applepay-complete', data, config);
    },
    CancelOrderItem: function(data, config) {
        this._send('/checkout/order-actions/cancel-order-line', data, config);
    },
    RequestSigninCode: function (data, config) {
        this._send('/signin/request-code', data, config);
    },
    CheckProductReviewable: function (data, config) {
        config.dataType = 'json';
        this._ajaxGet('/products/check-reviewable/' + data.productIdentity, data, config);
    },

    _send: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf('=') === -1 ? '' : '&';
            data += joiner + '_ts=' + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'POST',
                data: data,
                context: this,
                dataType: 'json',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function () {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback));
                    }
                    else if (config.callback) {
                        config.callback.call((config.scope || config.callback), true);
                    }
                }
            }
        );
    },

    _ajaxGet: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf('=') === -1 ? '' : '&';
            data += joiner + '_ts=' + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'GET',
                data: data,
                context: this,
                dataType: config.dataType || 'html',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function (xhr, status) {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback), status);
                    }
                }
            }
        );
    },

    _get: function(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf('=') === -1 ? '' : '&';
            data += joiner + '_ts=' + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'GET',
                data: data,
                context: this,
                dataType: 'json',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-Requested-With', { toString: function () { return ''; } });
                },
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function (xhr, status) {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback), status);
                    }
                }
            }
        );
    }
};


// WEBPACK FOOTER //
// ./assets/js/HSN/Service/CommerceService.js